export const determineBgColor = (selected?: boolean, active?: boolean): string =>
  selected || active ? 'action-bg-neutral-hover' : 'action-bg-neutral-default';

export const determineSize = (small?: boolean): string => (small ? 'py-xxs! px-xs!' : '');
